type YmFunction = (
  id: number,
  type: string,
  goal: string,
  params?: unknown,
) => void;

type PlausibleFunction = (
  event: string,
  options?: { props: Record<string, unknown> },
) => void;

const sendCounterEvent = (
  name: string,
  params?: Record<string, unknown>,
): void => {
  const ym = (window as unknown as { ym?: YmFunction }).ym;
  if (!ym) {
    console.warn("Yandex Metrica is not installed");
    return;
  }
  ym(86035883, "reachGoal", name, params);
};

const sendPlausibleEvent = (
  name: string,
  params?: Record<string, unknown>,
): void => {
  const plausible = (window as unknown as { plausible?: PlausibleFunction })
    .plausible;
  if (!plausible) return;
  plausible(name, params ? { props: params } : undefined);
};

const sendAnalyticsEvent = (
  name: string,
  params?: Record<string, unknown>,
): void => {
  sendCounterEvent(name, params);
  sendPlausibleEvent(name, params);
};

export { sendAnalyticsEvent, sendCounterEvent, sendPlausibleEvent };
